export enum enProductType {
  INFO = 1,
  JOB = 2,
  PHYSICAL = 3,
  TICKET = 4,
  PACKAGE = 6,
  PROJECT = 8
}
